import React from "react";
import "./NewArrival.scss";
import { Link } from "react-router-dom";

function NewArrival() {
  return (
    <div>
      <div className="sub-title-heading">Nổi bật</div>
      <h3 className="title-heading">
        <a href="/">Sản phẩm mới</a>
      </h3>
      <div className="list-products">
        <div
          className="item-product item1"
          style={{
            backgroundImage:
              "url('https://i.pinimg.com/originals/33/e4/06/33e4060976462d6825ce0cbcb3704658.jpg')",
          }}
        >
          <h5 className="title-product">Tên sản phẩm</h5>
          <p className="sub-title-product">Mô tả ngắn về sản phẩm</p>
          <Link href="/" type="button" className="btn-view-now">
            Xem Ngay
          </Link>
        </div>
        <div
          className="item-product item2"
          style={{
            backgroundImage:
              "url('https://inkythuatso.com/uploads/images/2022/03/anh-my-do-toa-nu-vuong-xinh-dep-1-16-17-01-12.jpg')",
          }}
        >
          <h5 className="title-product">Tên sản phẩm</h5>
          <p className="sub-title-product">Mô tả ngắn về sản phẩm</p>
          <Link href="/" type="button" className="btn-view-now">
            Xem Ngay
          </Link>
        </div>
        <div
          className="item-product item3"
          style={{
            backgroundImage:
              "url('https://i.ytimg.com/vi/1l_YadQTg5Q/maxresdefault.jpg')",
          }}
        >
          <h5 className="title-product">Tên sản phẩm</h5>
          <p className="sub-title-product">Mô tả ngắn về sản phẩm</p>
          <Link href="/" type="button" className="btn-view-now">
            Xem Ngay
          </Link>
        </div>
      </div>
    </div>
  );
}

export default NewArrival;
